module.exports = __webpack_public_path__ + "static/media/hat-chef.ff4d3def.svg";